import { baseApi, client } from '../baseApi.ts';
import GetProfileResponse from '../response/GetProfileResponse.ts';

export const userEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getUserProfile: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.user.profile();
					const data = new GetProfileResponse(response?.data).formatResponse();
					return { data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['UserProfile'],
		}),
		updateUserProfile: builder.mutation({
			// @ts-ignore
			queryFn: async (request: any) => {
				try {
					const response = await client.user.update(request);
					const data = new GetProfileResponse(response?.data).formatResponse();
					return { data };
				} catch (error) {
					return { error };
				}
			},
			invalidatesTags: ['UserProfile'],
		}),
	}),
});

export default userEndpoints;
